import axios from "axios";

const API = "http://129.153.124.232:3000/api/channels";

function authConfig(token) {
  return { headers: { Authorization: `Bearer ${token}` } };
}

export const getChannels = (token) =>
  axios.get(API, authConfig(token));

export const getAdminChannels = (token) =>
  axios.get(`${API}/admin`, authConfig(token));

export const createChannel = (token, values) =>
  axios.post(API, values, authConfig(token));

export const updateChannel = (token, channelId, values) =>
  axios.patch(`${API}/${encodeURIComponent(channelId)}`, values, authConfig(token));

export const archiveChannel = (token, channelId) =>
  axios.delete(`${API}/${encodeURIComponent(channelId)}`, authConfig(token));